import { NotificationSettingsGroup } from "src/shared/types/src/lib/notification.types";


const data: NotificationSettingsGroup[] = [
  {
    groupName: 'Financials',
    groupKey: 'FINANCIALS',
    notificationSettings: [
      {
        title: 'Invoices & Payments',
        settingsKey: 'INVOICES_PAYMENTS'
      },
      {
        title: 'Overdue Balance & Statements',
        settingsKey: 'OVERDUE_BALANCE_STATEMENTS'
      }
    ]
  },
  {
    groupName: 'Updates & Communication',
    groupKey: 'UPDATES_COMMUNICATION',
    notificationSettings: [
      {
        title: 'Messages',
        settingsKey: 'MESSAGES'
      },
      {
        title: 'Observations',
        settingsKey: 'OBSERVATIONS'
      },
      {
        title: 'Daily Diaries',
        settingsKey: 'DAILY_DIARIES'
      },
      {
        title: 'Newsfeed',
        settingsKey: 'NEWSFEED'
      },
      {
        title: 'Sessions',
        settingsKey: 'SESSIONS'
      }
    ]
  },
  {
    groupName: 'Wellbeing',
    groupKey: 'WELLBEING',
    notificationSettings: [
      {
        title: 'Incident/Accident Sheets',
        settingsKey: 'INCIDENT_ACCIDENT_SHEETS'
      },
      {
        title: 'Medicine Forms',
        settingsKey: 'MEDICINE_FORMS'
      }
    ]
  },
  {
    groupName: 'Reports & Resources',
    groupKey: 'REPORTS_RESOURCES',
    notificationSettings: [
      {
        title: 'Reports',
        settingsKey: 'REPORTS'
      },
      {
        title: 'Planning Sheets',
        settingsKey: 'PLANNING_SHEETS'
      },
      {
        title: 'Resources & Documents',
        settingsKey: 'RESOURCES_DOCUMENTS'
      }
    ]
  }
]

export default data;